import { ReactNode } from "react";
import { usePWACache } from "@/hooks/usePWACache";

interface PWACacheProviderProps {
  children: ReactNode;
}

export function PWACacheProvider({ children }: PWACacheProviderProps) {
  // Initialize PWA caching
  usePWACache();

  return <>{children}</>;
}
